import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {UserPickerComponent} from './components/user-picker.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EllipsisPipe} from './pipes/ellipsis.pipe';
import {ProjectNrPipe} from './pipes/project-nr.pipe';

import {TimestampPipe} from './pipes/timestamp.pipe';
import {LinkListDialogComponent} from './link-list-dialog/link-list-dialog.component';
import {CompanySearchComponent} from './company-search/company-search.component';
import {CountrySelectorComponent} from './country-selector/country-selector.component';
import {ProjectSelectorComponent} from './project-selector-component/project-selector-component.component';
import {BudgetListFilterComponent} from './budget-list-filter/budget-list-filter.component';
import {ConfirmationDialogComponent} from '../components/confirmation-dialog/confirmation-dialog.component';



@NgModule({
    imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    UserPickerComponent,
    EllipsisPipe,
    ProjectNrPipe,
    TimestampPipe,
    LinkListDialogComponent,
    CompanySearchComponent,
    CountrySelectorComponent,
    ProjectSelectorComponent,
    BudgetListFilterComponent,
    ConfirmationDialogComponent
],
    exports: [
    UserPickerComponent,
    EllipsisPipe,
    ProjectNrPipe,
    TimestampPipe,
    CompanySearchComponent,
    CountrySelectorComponent,
    ProjectSelectorComponent,
    BudgetListFilterComponent
],
    providers: [
        EllipsisPipe,
        ProjectNrPipe,
        TimestampPipe
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [TimestampPipe]
        };
    }
}